import { Navigate } from "react-router-dom";
import { USER_ROLES, UserWithRole } from "../../contexts/user/user.context";
import supabase from "../../shared/database/supabase";
import { canAccess } from "../../shared/auth/access-control";

interface RoleProtectedRouteProps {
  allowedRoles: readonly string[];
  children: React.ReactNode;
}

const RoleProtectedRoute: React.FC<RoleProtectedRouteProps> = ({ allowedRoles, children }) => {
  const user = supabase.auth.user() as UserWithRole | null;

  if (!user) {
    return <Navigate to="/auth/sign-in" replace />;
  }

  if (!user.user_metadata?.name) {
    return <Navigate to="/auth/sign-up?operation=finish" replace />;
  }

  const role = user.user_metadata?.role || USER_ROLES.USER;
  if (!canAccess(role, allowedRoles)) {
    const fallback = role === USER_ROLES.USER ? "/mechanics/pericias/list" : "/home";
    return <Navigate to={fallback} replace />;
  }

  return <>{children}</>;
};

export default RoleProtectedRoute;

